import templateUrl from './adp-files-dashboard.component.html';
import { EmploymentProcessingService } from '../../../../core/services';
import { UtilityService } from '../../../../core/services/utility.service';
import { IQService, ILogService } from 'angular';
import { getExceptionMessage } from '../../../../core/data-utils';
import { NewHireVM } from '../../../employment-processing/employment-processing-models';
import { NewHiresProcessor } from '../../../employment-processing/new-hires-processor.service';
import { TerminationsProcessor } from '../../../employment-processing/terminations-processor.service';

export const AdpFilesDashboardComponent = {
    templateUrl,
    controller: AdpFilesContainerController,
    controllerAs: "vm"
};

function AdpFilesContainerController($q: IQService, $log: ILogService, utilityService: UtilityService,
    employmentProcessingService: EmploymentProcessingService, newHiresProcessor: NewHiresProcessor,
    terminationsProcessor: TerminationsProcessor, payrollService, icdCorporationService, apexApiUrl: string) {
    'ngInject';

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.$onInit = onInit;
    vm.payWeekList;
    vm.corporationList;
    vm.corporation;
    vm.payWeek;
    vm.payWeek;
    vm.processedPayrollDate;
    vm.createAdpImportFile = createAdpImportFile;
    vm.createAdpCanadaImportFile = createAdpCanadaImportFile;
    vm.createNewHiresReportAll = createNewHiresReportAll;
    vm.createTerminationsReportAll = createTerminationsReportAll;
    vm.uploadAdpImportNumbers = uploadAdpImportNumbers;
    vm.uploadTerminations = uploadTerminations;
    vm.finishNewAdpNumbersImport = finishNewAdpNumbersImport;
    vm.finishTerminationsImport = finishTerminationsImport;
    vm.downloadAdpPayrollSummary = downloadAdpPayrollSummary;
    vm.downloadProcessedPayroll = downloadProcessedPayroll;
    vm.cancelTerminationsImport = cancelTerminationsImport;
    vm.cancelNewAdpNumbersImport = cancelNewAdpNumbersImport;

    vm.handleChangeIcdCorporation = handleChangeIcdCorporation;

    function onInit() {
        vm.processedPayrollDate = new Date();
        vm.processedPayrollDate.setDate(vm.processedPayrollDate.getDate() - 30);
        loadPage(undefined);
    }

    function loadPage(icdCorporationID) {
        utilityService.showLoadingUntilResolved(
            getIcdCorporations()
                .then(function (icdCorporations) {
                    console.log(icdCorporations);
                    
                    vm.corporationList = icdCorporations;
                    vm.corporation = icdCorporations[0];
                    let corporationID = vm.corporation.Value;
                    // eslint-disable-next-line eqeqeq
                    if (icdCorporationID != undefined) {
                        corporationID = icdCorporationID;
                        vm.corporation = vm.corporationList.filter(function (corporation) {
                            // eslint-disable-next-line eqeqeq
                            return corporation.Value == icdCorporationID;
                        })[0];
                    }
                    return retrievePayrollList(corporationID)
                })
                .then(function (payrollList) {
                    vm.payWeekList = payrollList.sort(function (a, b) {
                        return a.StartDate < b.StartDate ? 1 : -1;
                    });
                    vm.payWeek = payrollList[0];
                })
                .catch(function (ex) {
                    console.error(ex);
                    alert("initial load failed:" + utilityService.getExceptionMessage(ex));
                })
        );
    }

    function retrievePayrollList(icdCorporationID) {
        return payrollService.retrieveIcdCorporationPayrolls(icdCorporationID)
            .then(function (payWeeks) {
                return payWeeks.map(function (payWeek) {
                    return {
                        PayWeekID: payWeek.PayrollID,
                        Text: kendo.format("{0:MM/dd/yyyy} - {1:MM/dd/yyyy}", payWeek.StartDate, payWeek.EndDate),
                        StartDate: payWeek.StartDate,
                        EndDate: payWeek.EndDate,
                        IcdCorporationID: payWeek.IcdCorporationID,
                        PayrollID: payWeek.PayrollID
                    };
                });
            })
    }

    function getIcdCorporations() {
        return icdCorporationService.retrieveIcdCorporations()
            .then(function (icdCorporations) {
                return jQuery.map(icdCorporations, function (icdCorporation) {
                    return [{
                        Value: icdCorporation.Id,
                        Text: icdCorporation.ClientName + (icdCorporation.ClientAs != null ? ' - ' + icdCorporation.ClientAs : '')
                    }];
                });
            });
    }

    function createAdpImportFile() {
        const urlStrPayroll = kendo.format(apexApiUrl + '/payrolls/{0}/adp-import-file.csv',
            vm.payWeek.PayrollID);
        try {
            window.location.href = urlStrPayroll;
        } catch (err) {
            alert("Creation of ADP Import File Failed:" + err.message);
        }
    }

    function createAdpCanadaImportFile() {
        const urlStrPayroll = kendo.format(apexApiUrl + '/payrolls/{0}/adp-canada-import-file.csv',
            vm.payWeek.PayrollID);
        window.location.href = urlStrPayroll;
    }

    function createNewHiresReportAll() {
        window.location.href = apexApiUrl + "/employments/new-hires.xlsx";
    }

    function createTerminationsReportAll() {
        window.location.href = apexApiUrl + "/employments/terminations.xlsx";
    }

    function downloadAdpPayrollSummary() {
        const urlStrPayroll = kendo.format(apexApiUrl + "/payrolls/adp-payroll-summary?icdCorporationID={0}&startDate={1:yyyy-MM-dd}&endDate={2:yyyy-MM-dd}",
            vm.corporation.Value, vm.payWeek.StartDate, vm.payWeek.EndDate);
        window.location.href = urlStrPayroll;
    }

    function downloadProcessedPayroll() {
        const urlStrPayroll = kendo.format(apexApiUrl + "payrolls/processed-payrolls?completedDate={0:yyyy-MM-dd}",
            vm.processedPayrollDate);
        window.location.href = urlStrPayroll;
    }

    function uploadAdpImportNumbers() {

        if (!vm.importADPNumbersFiles) return;

        const file = vm.importADPNumbersFiles;
        if (file) {
            vm.importADPNumbersFile = file;
            vm.newADPEmpNumbers = null;
            utilityService.showLoading();
            employmentProcessingService.parseNewHiresDataFromFile(file)
                .then(function (newHires: NewHireVM[]) {
                    for (let i = 0; i < newHires.length; i++) {
                        newHires[i].isSelected = (newHires[i].ADPEmployeeID || "") !== "";
                    }
                    vm.newADPEmpNumbers = newHires;
                })
                .catch(function (ex) {
                    vm.importADPNumbersFile = null;
                    alert("Reading the file failed. Please make sure it is in the correct format.");
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        }
    }

    function finishNewAdpNumbersImport() {
        const hires = vm.newADPEmpNumbers.filter(e => e.isSelected);
        // Minimize the number of simulataneous requests by capping off a chunk of batch updates.
        const maxChunkSize = 20;
        const result = {
            succeeded: 0,
            failed: 0,
            totalCount: hires.length,
            messages: [],
            promises: []
        };
        let chunkPromise = $q.resolve();
        for (let i = 0; i < hires.length; i += maxChunkSize) {
            const chunkHires = hires.slice(i, i + maxChunkSize);
            chunkPromise = chunkPromise.then(() => newHiresProcessor.batchProcessNewHires(chunkHires))
                .then(chunkResult => {
                    result.succeeded += chunkResult.succeeded;
                    result.failed += chunkResult.failed;
                    result.messages.push(...chunkResult.messages);
                });
        }

        const allSaved = chunkPromise.then(() => {
            if (result.failed) {
                const count = result.totalCount;
                alert(`There was an error processing the new hires. ${result.succeeded}/${count}
                    succeeded, ${result.failed}/${count} failed`);
                $log.warn("New hires processing failed.", result.messages);
                return;
            }
            alert("All selected new hires were processed successfully");
        })
            .catch(ex => {
                // Note, this isn't the usual case where a single update failed.
                $log.error(ex);
                alert("Saving failed: " + getExceptionMessage(ex))
            });

        utilityService.showLoadingUntilResolved(allSaved);
    }

    function finishTerminationsImport() {
        //TODO: Refactor this entire piece of logic (parsing and processing) into a shared component.
        const terminations = vm.terminatedEmployees.filter(function (employee) {
            return employee.isSelected;
        });
        // Minimize the number of simulataneous requests by capping off a chunk of batch updates.
        const maxChunkSize = 20;
        const result = {
            succeeded: 0,
            failed: 0,
            totalCount: terminations.length,
            messages: [],
            promises: []
        };
        let chunkPromise = $q.resolve();
        for (let i = 0; i < terminations.length; i += maxChunkSize) {
            const chunkTerminations = terminations.slice(i, i + maxChunkSize);
            chunkPromise = chunkPromise
                .then(() => terminationsProcessor.batchProcessTermination(chunkTerminations))
                .then(chunkResult => {
                    result.succeeded += chunkResult.succeeded;
                    result.failed += chunkResult.failed;
                    result.messages.push(...chunkResult.messages);
                });
        }

        const allSaved = chunkPromise.then(() => {
            if (result.failed) {
                const count = result.totalCount;
                alert(`There was an error processing the terminations. ${result.succeeded}/${count}
                    succeeded, ${result.failed}/${count} failed`);
                $log.warn("Terminations processing failed.", result.messages);
                return;
            }
            alert("All selected terminations were processed successfully");
        })
            .catch(ex => {
                // Note, this isn't the usual case where a single update failed.
                $log.error(ex);
                alert("Saving failed: " + getExceptionMessage(ex))
            });
        utilityService.showLoadingUntilResolved(allSaved);
    }

    function cancelNewAdpNumbersImport() {
        vm.importADPNumbersFiles = null;
        vm.importADPNumbersFile = null;
        vm.newADPEmpNumbers = null;
    }

    function cancelTerminationsImport() {
        vm.terminationsFiles = null;
        vm.terminationsFile = null;
        vm.terminatedEmployees = null;
    }

    function uploadTerminations() {
        if (!vm.terminationsFiles) return;

        const file = vm.terminationsFiles;
        if (file) {
            vm.terminationsFile = file;
            vm.terminatedEmployees = null;
            utilityService.showLoading();
            employmentProcessingService.parseTerminationsDataFromFile(file)
                .then(function (terminations) {
                    for (let i = 0; i < terminations.length; i++) {
                        terminations[i].isSelected = true;
                    }
                    vm.terminatedEmployees = terminations;
                })
                .catch(function (ex) {
                    vm.terminationsFile = null;
                    alert("Reading the file failed. Please make sure it is in the correct format.");
                })
                .then(function () {
                    utilityService.hideLoading();
                });
        }
    }

    function handleChangeIcdCorporation() {
        loadPage(vm.corporation.Value);
    }
}
